module.exports = __webpack_public_path__ + "img/sb1.024e3e60.png";